import { Spin } from "antd";

const Loader = ({children, loading=false}) => {
  return (
    <>
      <Spin spinning={loading} style={styleSheet.loaderStyle} tip="Loading..." fullscreen={true}>        {children}</Spin>
    </>
  );
};

export default Loader;

const styleSheet = {
  loaderStyle: { background: "rgba(0,0,0,0.8)" }
};
